/* global CustomFunctions */

export function getErrorMessage(e: unknown): string {
  if (e instanceof CustomFunctions.Error) {
    return e.message || "Erro no suplemento Cognito.";
  }
  if (e instanceof Error) {
    return e.message || e.name;
  }
  return String(e);
}

export function handleScalarError(functionName: string, e: unknown): string {
  const message = getErrorMessage(e);
  console.error(`[Cognito Excel] ${functionName} falhou`, e);
  return `ERRO COGNITO (${functionName}): ${message}`;
}

export function handleTableError(functionName: string, e: unknown): any[][] {
  const message = getErrorMessage(e);
  console.error(`[Cognito Excel] ${functionName} falhou`, e);
  return [
    ["Erro Cognito", functionName],
    ["Detalhe", message],
  ];
}
